import { shape, string } from 'prop-types';
import qs from 'query-string';
import React from 'react';

import Titled from '../layout/Titled';
import api from '../REST/api';
import AuthorizedLink from '../REST/AuthorizedLink';
import withResolved from '../REST/with-resolved';
import List from './List';

const UsersList = withResolved({
  query: api.getUsers,
  as: 'data',
})(List);

const ListUsers = ({ location }) => {
  const { team } = qs.parse(location.search);
  return (
    <Titled
      title="Users"
      actions={
        <AuthorizedLink
          to="/users/add"
          className="btn btn-secondary"
          query={api.addUser}
        >
          Create User
        </AuthorizedLink>
      }
    >
      <UsersList team={team} />
    </Titled>
  );
};

ListUsers.propTypes = { location: shape({ search: string }).isRequired };

export default ListUsers;
